import axios from "axios";
import config from '../../config'
// const BASE_URL = "http://3.22.188.65:8080"
const BASE_URL = config.apiUrl


const GetlistePages = async () =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
      try {
        const response = await instance.get("/rabat-zoo/page-info/api/all" ); 
        return response.data;
      } catch (error) { 
          throw error.response 
      }
}

const AddPage = async (DataPost) =>{

    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.post("/rabat-zoo/page-info/api/add",DataPost ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const updatePage = async (DataPost) =>{

    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.put("/rabat-zoo/page-info/api/update",DataPost ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const disablePage = async (id) =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.get("/rabat-zoo/page-info/api/disable/" + id ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const removePage = async (id) =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.get("/rabat-zoo/page-info/api/remove/" + id ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const enablepage = async (id) =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.get("/rabat-zoo/page-info/api/enable/" + id ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const UploadFilePage = async (formData) =>{

    const options = {
        baseURL: BASE_URL,
        headers: {
            'Content-Type': 'multipart/form-data',
          },
    }
  
    const instance = axios.create(options)
      try {
        const response = await instance.post("/rabat-zoo/page-info/api/upload",formData ); 
        return response.data;
      } catch (error) { 
          throw error.response 
      }
  }




export {GetlistePages,AddPage,UploadFilePage,updatePage, disablePage, enablepage,removePage}
